import React, { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { useConfig } from '../../../../ConfigContext';
import { get, patch } from '../../../../utils/Request';
import { useSnackbar } from '../../../../snackbar/SnackbarContext';
import { GameIds, MarketingPlayerSubscriptions } from '../../MyGames.model';

interface Props {
  sectionTitle: string;
  title: string;
  description: string;
  subscribeButtonText: string;
  subscriptionConfirmation: string;
  gameId: GameIds;
  tos: string;
  subscribedMessages: string[];

}
export function GameNewsletters(props: Props): JSX.Element {
  const config = useConfig();
  const snackbar = useSnackbar();

  const [tosAccepted, setTosAccepted] = useState<boolean>(false);
  const [isPlayerSubscribed, setIsPlayerSubscribed] = useState<boolean>(false);
  const [subscriptionsPerProjects, setSubscriptionsPerProjects] = useState<MarketingPlayerSubscriptions[]>([]);
  const [gameSubscriptions, setGameSubscriptions] = useState<MarketingPlayerSubscriptions>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getPlayerSubscriptions = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const subscriptions = await
      get<MarketingPlayerSubscriptions[]>(`${config.clientConfig?.host}/players/me/marketing/subscriptions`);
      setSubscriptionsPerProjects(subscriptions);
      const currentGameSubscriptions = subscriptions.find((sub) => sub.project === props.gameId);
      setGameSubscriptions(currentGameSubscriptions);
      if (currentGameSubscriptions) {
        const messagesAvailable = props.subscribedMessages
          .every((message) => currentGameSubscriptions.subscribedMessages.includes(message));
        setIsPlayerSubscribed(messagesAvailable);
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      snackbar.addErrorMessage('UnknownError');
    }
  };

  const handleSubscription = async (): Promise<void> => {
    let currentGameSub: MarketingPlayerSubscriptions;
    try {
      if (gameSubscriptions) {
        const subs = [...gameSubscriptions.subscribedMessages, ...props.subscribedMessages];
        currentGameSub = {
          project: props.gameId,
          subscribedMessages: subs.filter((c, index) => subs.indexOf(c) !== index),
        };
      } else {
        currentGameSub = {
          project: props.gameId,
          subscribedMessages: props.subscribedMessages,
        };
      }
      currentGameSub = {
        project: props.gameId,
        subscribedMessages: props.subscribedMessages,
      };
      await patch<MarketingPlayerSubscriptions[]>(`${config.clientConfig?.host}/players/me/marketing/subscriptions`, {
        data: {
          subscriptionsPerProjects: [
            ...subscriptionsPerProjects.filter((sub) => sub.project !== props.gameId),
            currentGameSub,
          ],
        },
      });
      setIsPlayerSubscribed(true);
    } catch (e) {
      snackbar.addErrorMessage('UnknownError');
    }
  };

  useEffect(() => {
    getPlayerSubscriptions();
  }, [props.gameId]);

  return (
    <div className='game-newsletter' data-cy={`${props.gameId}-newsletters`}>
      <h3 className='section-title'>{props.sectionTitle}</h3>
      <div className='items-container text-center'>
        {isLoading ? <CircularProgress color='inherit' /> : (
          <>
            <h4>{props.title}</h4>

            <div className='description'>
              {props.description}
            </div>
            {!isPlayerSubscribed
              && (
                <div className='tos'>
                  <input
                    className='survey-input'
                    type='checkbox'
                    id='terms'
                    name='terms'
                    checked={tosAccepted}
                    onChange={(e) => setTosAccepted(e.target.checked)}
                    data-cy={`${props.gameId}-terms-checkbox`}
                  />
                  <label htmlFor='terms'>
                    {props.tos}
                  </label>
                </div>
              )}

            <button
              type='button'
              data-cy={`${props.gameId}-newsletters-btn`}
              disabled={!tosAccepted || isPlayerSubscribed}
              onClick={handleSubscription}
              className='btn btn-primary-game btn-block mx-auto btn-newsletter'
            >
              {isPlayerSubscribed ? props.subscriptionConfirmation : props.subscribeButtonText}
            </button>

          </>
        )}
      </div>
    </div>
  );
}
